import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgDeliveryOffline',
})
export default class CmgDeliveryOffline extends Vue {

  get sadAvocado() {
    return this.$appStore.state.cms.images.feedback.sadAvocado.default;
  }
}
